import "./App.css";
import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "../../components/Header/Header";
import Promo from "../../components/Promo/Promo";
import About from "../About/About";
import Preview from "../Preview/Preview";
import ButtonsBar from "../ButtonsBar/ButtonsBar";
import Feedback from "../Feedback/Feedback";
import Footer from "../Footer/Footer";

import PropertyDevelopment from "../PropertyDevelopment/PropertyDevelopment";
import ContructionMaterials from "../ContructionMaterials/ContructionMaterials";
import InvestmentOpportnites from "../InvestmentOpportnites/InvestmentOpportnites";
import Gallery from "../Gallery/Gallery";
import Contact from "../Contact/Contact";
import "./ServicePages.css";

function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <div className="app">
      <ScrollToHash />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <Promo />
              <About />
              <Preview />
              <Contact />
              {/* <Feedback /> */}
              <ButtonsBar />
              <Footer />
            </>
          }
        />
        <Route
          path="/property-development"
          element={
            <>
              <Header />
              <PropertyDevelopment />
              <ButtonsBar />
              <Footer />
            </>
          }
        />
        <Route
          path="/construction-materials"
          element={
            <>
              <Header />
              <ContructionMaterials />
              <ButtonsBar />
              <Footer />
            </>
          }
        />
        <Route
          path="/investment-opportnites"
          element={
            <>
              <Header />
              <InvestmentOpportnites />
              <ButtonsBar />
              <Footer />
            </>
          }
        />
        <Route
          path="/gallery"
          element={
            <>
              <Header />
              <Gallery />
              <ButtonsBar />
              <Footer />
            </>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
